import styled from 'styled-components';

export * from './base.styled';

export const DetailsBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  font-style: normal;
  font-size: 0.9375rem;
  font-family: ${Styles.fontFamily.body};
  ${Styles.desktop`
      padding: 0 1.5rem 1.25rem;
  `}
`;

export const Text = styled.div`
  padding-top: 1rem;
  padding-bottom: 1rem;
  position: relative;
`;

export const Address = styled.span`
  font-weight: ${Styles.fontWeight.normal};
`;

export const LinkDisplay = styled.div`
  position: relative;
`;
